import { createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b4be8c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal",
  "aria-modal": "true",
  role: "dialog"
}
const _hoisted_2 = { class: "modal__wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-cross" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  class: "modal__header",
  "data-test": "header-warningModalHeaderText"
}
const _hoisted_7 = {
  class: "modal__body",
  "data-test": "section-warningModalBodyText"
}
const _hoisted_8 = { class: "modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal__mask",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.maskClicked($event)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.bodyClicked && _ctx.bodyClicked(...args))),
          class: _normalizeClass(`modal__container--${_ctx.large ? 'large' : 'small'}`)
        }, [
          (_ctx.showClose)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "tag tag--pill-icon modal__close-button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["enter"])),
                tabindex: "0",
                title: "Close"
              }, _hoisted_5, 32))
            : _createCommentVNode("", true),
          _createElementVNode("header", _hoisted_6, [
            _renderSlot(_ctx.$slots, "modalHeader", {}, undefined, true)
          ]),
          _createElementVNode("section", _hoisted_7, [
            _renderSlot(_ctx.$slots, "modalBody", {}, undefined, true)
          ]),
          _createElementVNode("footer", _hoisted_8, [
            _renderSlot(_ctx.$slots, "modalFooter", {}, undefined, true)
          ])
        ], 2)
      ])
    ])
  ]))
}